/* eslint-disable no-unused-vars */

/* eslint-disable no-nested-ternary */

/* eslint-disable react/no-array-index-key, jam3/no-sanitizer-with-danger */

// import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
/**
 *
 * ListFilters
 *
 */
import classNames from 'classnames/bind'
import React from 'react'

import LoadingIndicator from '../../LoadingIndicator'
// import Checkbox from '@material-ui/core/Checkbox';
import TablePaginationActions from '../../TablePagination'
import TableHead from './TableHead'

// import { FormattedMessage } from 'react-intl';
// import messages from './messages';

// biome-ignore lint/correctness/noUnusedVariables: TODO
const styles = theme => ({
  loaderStyle: {
    width: '100%',
    padding: '20px',
    height: `${48 * 5}px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

/* eslint-disable react/prefer-stateless-function */
class SimpleTable extends React.Component {
  tableRow = () => {
    // biome-ignore lint/correctness/noUnusedVariables: TODO
    const { tHeadData, tData, classes } = this.props

    return tData.map((item, key) => (
      <TableRow
        hover
        role="checkbox"
        tabIndex={-1}
        key={`row${
          // biome-ignore lint/suspicious/noArrayIndexKey: TODO
          key
        }`}
        scope="row"
      >
        {Object.keys(item).map((keys, index) => (
          <TableCell
            key={`${
              // biome-ignore lint/suspicious/noArrayIndexKey: TODO
              index
            }_cell`}
            className={classNames(classes.tableRow)}
            // biome-ignore lint/security/noDangerouslySetInnerHtml: TODO
            dangerouslySetInnerHTML={{ __html: item[keys] }}
          />
        ))}
      </TableRow>
    ))
  }

  render() {
    const {
      tHeadData,
      tData,
      isPaggination,
      classes,
      totalRecords,
      pageSize,
      loading,
      children,
      handleChangePage,
      page,
    } = this.props
    return (
      <Table className={classes.root} aria-labelledby="tableTitle">
        <TableHead data={tHeadData} />
        <TableBody>
          {loading ? (
            <TableRow className="text-align-center">
              <TableCell colSpan={tHeadData.length}>
                <LoadingIndicator className={classes.loaderStyle} />
              </TableCell>
            </TableRow>
          ) : tData ? (
            totalRecords <= 0 ? (
              <div className={classes.loaderStyle}>
                <p>No Data Found</p>
              </div>
            ) : (
              this.tableRow()
            )
          ) : (
            children
          )}
        </TableBody>
        {isPaggination ? (
          <TableFooter>
            <TableRow>
              <TablePagination
                colSpan={tHeadData.length}
                count={totalRecords}
                rowsPerPage={pageSize}
                rowsPerPageOptions={[pageSize]}
                page={page}
                onChangePage={handleChangePage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        ) : (
          ''
        )}
      </Table>
    )
  }
}

SimpleTable.defaultProps = {
  isPaggination: true,
}
export default withStyles(styles)(SimpleTable)
